export default __webpack_public_path__ + "static/media/elasticsearch-logo.9f79f43e.svg";